import { Skeleton } from '@mui/material';
import React, { useMemo } from 'react';

import { useFetchData } from '../../hooks/useFetchData';
import { CategoryProgress } from '../../Types/dealGPT';
import { projectRunProgressPathUrl } from '../../util/routesUrls';
import StatusProgressBar from './StatusProgressBar';

export type ProjectProgressBarProps = {
  projectId: string;
  runId: string | undefined;
};

const ProjectProgressBar = ({ projectId, runId }: ProjectProgressBarProps) => {
  const { data: progress, loading } = useFetchData<CategoryProgress[]>({
    urlPath: projectRunProgressPathUrl(projectId, runId ?? ''),
    skip: !runId,
  });

  const aggregatedProgress = useMemo(
    () =>
      (progress ?? []).reduce(
        (acc, categoryProgress) => ({
          quantity: acc.quantity + categoryProgress.quantity,
          quantityAnswered: acc.quantityAnswered + categoryProgress.quantityAnswered,
          quantityMoreInfoNeeded:
            acc.quantityMoreInfoNeeded + categoryProgress.quantityMoreInfoNeeded,
          quantityNotFound: acc.quantityNotFound + categoryProgress.quantityNotFound,
          quantitySkipped: acc.quantitySkipped + categoryProgress.quantitySkipped,
        }),
        {
          quantity: 0,
          quantityAnswered: 0,
          quantityMoreInfoNeeded: 0,
          quantityNotFound: 0,
          quantitySkipped: 0,
        }
      ),
    [progress]
  );

  if (loading) return <Skeleton variant="rounded" height={15} width="100%" />;

  return (
    <StatusProgressBar
      quantity={aggregatedProgress.quantity}
      quantityAnswered={aggregatedProgress.quantityAnswered}
      quantityMoreInfoNeeded={aggregatedProgress.quantityMoreInfoNeeded}
      quantityNotFound={aggregatedProgress.quantityNotFound}
      quantitySkipped={aggregatedProgress.quantitySkipped}
    />
  );
};

export default ProjectProgressBar;
